import Vue from "vue";
import { menuList } from '../config/routerConfig'
import config from './config'
import Router from '../router/index'
const bus = new Vue();

// 处理menu成一个数组
let _menuList = [{path: 'home'}]
let dealMenu = function(menuList) {
  for (let m of menuList) {
    const cItem = {
      path: m.path
    }
    if (m.children) {
      dealMenu(m.children)
    }
    _menuList.push(cItem)
  }
}
dealMenu(menuList)

// 关闭当前页面
const closeCurrent = function () {
  if (config.showlabel === 'ALL') {
    bus.$emit('close_current_page')
  } else {
    Router.go(-1)
  }
}
export { 
  bus,
  _menuList,
  closeCurrent
};
